import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import moment from "moment";
import ReactTable from "react-table";
import { DatePicker } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import SearchSelect from "components/common/SearchSelect";
import filterCaseInsensitive from "components/custom/forms/react-table-case-insensitive";

import { fetchHelperJobsLookup } from "api/menu/master-files/job-maintenance/actions";
import { fetchServiceTypes } from "actions/serviceTypeActions";
import {
    deleteJob,
    updateJob,
    addDateToJobProduct,
    deleteDateToJobProduct
} from "actions/draftActions";

const { RangePicker } = DatePicker;

class JobTable extends React.Component {
    dateFormat = "YYYY-MM-DD";

    constructor(props) {
        super(props);
        this.state = {
            helperJobOptions: []
        };

        this.handleClickDelBtnOnJobs = this.handleClickDelBtnOnJobs.bind(this);
        this.handleChangeSelect = this.handleChangeSelect.bind(this);
        this.handleChangeRangePicker = this.handleChangeRangePicker.bind(this);
    }

    componentDidMount() {
        this.props.fetchServiceTypes();
        if (this.props.draft.retailerId) {
            this.props.fetchHelperJobsLookup([this.props.draft.retailerId]);
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.draft.retailerId !== this.props.draft.retailerId
            && this.props.draft.retailerId) {
            this.props.fetchHelperJobsLookup([this.props.draft.retailerId]);
        }
        if (prevProps.helperJobs !== this.props.helperJobs) {
            const helperJobOptions = this.props.helperJobs.map(item => ({
                value: item.id,
                label: `${item.jobNumber} : ${item.hourlyRate}`
            }));
            this.setState({
                helperJobOptions
            });
        }
    }

    componentWillUnmount() {
        this.props.fetchServiceTypes(true);
        this.props.fetchHelperJobsLookup(undefined, true);
    }

    handleClickDelBtnOnJobs(id) {
        this.props.deleteJob(this.props.draft.id, id);
    }

    handleChangeSelect(id, jobProductId, helperJobProductId, serviceTypeId) {
        this.props.updateJob(
            id,
            this.props.draft.id,
            jobProductId,
            helperJobProductId,
            serviceTypeId
        );
    }

    handleChangeRangePicker(date, id) {
        if (date.length) {
            const startDate = date[0].format(this.dateFormat);
            const endDate = date[1].format(this.dateFormat);
            this.props.addDateToJobProduct(id, startDate, endDate, this.props.draft.id);
        } else {
            this.props.deleteDateToJobProduct(id, this.props.draft.id);
        }
    }

    render() {
        const {
            serviceTypes
        } = this.props;
        const serviceTypesOptions = serviceTypes.map((value) => ({
            value: value.id,
            label: value.name
        }));

        const columns = [
            {
                Header: "Jobs #",
                accessor: "jobNumber",
                id: "jobNumber",
                minWidth: 100
            },
            {
                Header: "Helper Job #",
                accessor: "",
                id: "helperJob",
                Cell: ({ original }) => {
                    const {
                      helperJobOptions
                    } = this.state;
                    const selected = helperJobOptions.find(item =>
                        item.value === original.helperJobProductId);
                    return (
                        <SearchSelect
                            className="g-filter-select-no-padding"
                            options={helperJobOptions}
                            isClearable={true}
                            isLoading={false}
                            value={selected}
                            valueKey="id"
                            isDisabled={this.props.readOnly}
                            onChange={(item) => {
                                const selectedValue = item ? item.value : null;
                                this.handleChangeSelect(
                                    original.id,
                                    original.jobProductId,
                                    selectedValue,
                                    original.serviceTypeId
                                );
                            }}
                        />
                    );
                },
                filterable: false,
                minWidth: 200,
                getProps: () => ({
                    style: {
                        display: "block",
                        overflow: "visible"
                    }
                })
            },
            {
                Header: "Supplier",
                accessor: "supplier",
                id: "supplier",
                minWidth: 150
            },
            {
                Header: "Product",
                accessor: "product",
                id: "product",
                minWidth: 150
            },

            {
                Header: "Service Type",
                accessor: "",
                id: "serviceType",
                Cell: ({ original }) => {
                    const selectedIndex = serviceTypesOptions.find(item =>
                        item.value === original.serviceTypeId);

                    return (
                        <SearchSelect
                            className="g-filter-select-no-padding"
                            options={serviceTypesOptions}
                            isClearable={true}
                            isLoading={false}
                            value={selectedIndex}
                            valueKey="id"
                            isDisabled={this.props.readOnly}
                            onChange={(item) => {
                                const selectedValue = item ? item.value : null;
                                this.handleChangeSelect(
                                    original.id,
                                    original.jobProductId,
                                    original.helperJobProductId,
                                    selectedValue
                                );
                            }}
                        />
                    );
                },
                filterable: false,
                minWidth: 200,
                getProps: () => ({
                    style: {
                        display: "block",
                        overflow: "visible"
                    }
                })
            },

            {
                Header: "Date range",
                accessor: "date",
                id: "date",
                minWidth: 250,
                Cell: ({ original }) => {
                    const startDate = original.startDate !== null
                        ? moment(original.startDate, this.dateFormat)
                        : null;
                    const endDate = original.endDate !== null
                        ? moment(original.endDate, this.dateFormat)
                        : null;
                    return (
                        <RangePicker
                            className="g-ant-input-no-padding"
                            disabled={this.props.readOnly}
                            value={[startDate, endDate]}
                            format={this.dateFormat}
                            onChange={(date) => this.handleChangeRangePicker(date, original.id)}
                        />
                    );
                },
                filterable: false,
                getProps: () => ({
                    style: {
                        display: "block",
                        overflow: "visible"
                    }
                })
            },
            {
                accessor: "",
                id: "delete",
                Header: "",
                Cell: ({ original }) => (
                    this.props.readOnly
                        ? null
                        : <FontAwesomeIcon
                            icon="times"
                            onClick={() => {
                                this.handleClickDelBtnOnJobs(original.id);
                            }}
                            style={{
                              cursor: "pointer"
                            }}
                        />
                ),
                sortable: false,
                filterable: false,
                width: 50,
                style: {
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                }
            }
        ];

        const {
          draftJobs
        } = this.props.draft;
        return (
            <ReactTable
                data={draftJobs}
                headerClassName="table-header"
                columns={columns}
                defaultPageSize={10}
                pageSize={Math.max((draftJobs ? draftJobs.length : 5), 5)}
                showPagination={false}
                pageSizeOptions={[10, 20, 50, 100]}
                resizable
                className="-striped -highlight"
                loading={this.props.loading}
                filterable={false}
                defaultSorted={[
                    {
                        id: "jobNumber",
                        desc: false
                    }
                ]}
                defaultFilterMethod={filterCaseInsensitive}
                style={{
                    height: "calc((100vh - 400px) / 2)",
                    minHeight: 250
                }}
                getTdProps={() => ({
                    style: {
                        display: "flex",
                        alignItems: "center",
                    }
                })}
            />
        );
    }
}

JobTable.propTypes = {
    draft: PropTypes.object.isRequired,
    loading: PropTypes.bool.isRequired,
    readOnly: PropTypes.bool.isRequired,
    helperJobOptions: PropTypes.array,
    helperJobs: PropTypes.array.isRequired,
    deleteJob: PropTypes.func.isRequired,
    updateJob: PropTypes.func.isRequired,
    fetchHelperJobsLookup: PropTypes.func.isRequired,
    fetchServiceTypes: PropTypes.func.isRequired,
    addDateToJobProduct: PropTypes.func.isRequired,
    deleteDateToJobProduct: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
    draft: state.draft.draft,
    loading: state.draft.loading,
    helperJobs: state.jobs.helperJobsLookup,
    serviceTypes: state.serviceTypes.serviceTypes,
});

const mapStateToDispatch = dispatch => ({
    deleteJob: bindActionCreators(deleteJob, dispatch),
    updateJob: bindActionCreators(updateJob, dispatch),
    fetchHelperJobsLookup: bindActionCreators(fetchHelperJobsLookup, dispatch),
    fetchServiceTypes: bindActionCreators(fetchServiceTypes, dispatch),
    addDateToJobProduct: bindActionCreators(addDateToJobProduct, dispatch),
    deleteDateToJobProduct: bindActionCreators(deleteDateToJobProduct, dispatch)
});

export default connect(mapStateToProps, mapStateToDispatch)(JobTable);
